import { isPubgm } from "@/constant";;

const isTestEnv = window.location.origin == "https://cloudgame.qcloud.com" ? false : true;
const isBrazilEnv = window.location.origin == "https://cloudgame-br.qcloud.com" ? true : false;
const isSgEnv = window.location.origin == "https://sg.cloudgame.qcloud.com" ? true : false;

// const PUBGM = isSgEnv ? '796m43' : '474ga5';
const GAME_ID = window.location.pathname.split('/').slice(-1)[0];

let PUBGM = "";
if (isPubgm()) {
  PUBGM = GAME_ID;
}

export const ADJUST_CONFIG_PC = {
  [PUBGM]: {
    app_token: 'd1up37red3i8',
    event_token: {
      web_launch: "s7zrnu",
      pc_popup_impression: "j2z6rr",
      ovm_popup_impression: "svdot5",
      loading_index: "ve6hg2"
    }
  }
};

export const ADJUST_CONFIG_H5 = {
  [PUBGM]: {
    app_token: 'd1up37red3i8',
    event_token: {
      ace: "vrfeqb",
      ace_dominator: "jemrbz",
      ace_master: "mdbhvp",
      add_friend: "axfzi4",
      app_launch: "xgv5nn",
      bronze: "o17s28",
      conqueror: "3bg7wa",
      country_completed: "7evsbq",
      country_start: "hppypk",
      createrole_completed: "8b5w2w",
      createrole_name_error: "hsyrq7",
      createrole_start: "9bpxcp",
      crown: "c0hha8",
      device_alloc_queue: "gukfjo",
      device_alloc_success: "z7lh1i",
      diamond: "is47y5",
      download_activity_btn_click: "dpla9j",
      downloadactivity_close_click: "2dkutj",
      downloadactivity_impression: "40lg3n",
      downloadactivity_impression_failed: "w2sffb",
      "download_banner-H5": "m2o6xq",
      download_lackfeature_cancel_click: "a4lzxf",
      download_lackfeature_download_click: "nmvuo8",
      download_lackfeature_popup_impression: "1k4ol6",
      download_remind_cancel_click: "hyftv4",
      download_remind_download_click: "a1k7ak",
      download_remind_popup_impression: "j67ags",
      duo: "7ybwcj",
      error_device_abnormal: "rfvbn8",
      error_device_none: "g2mcna",
      error_link_fail: "dc0p7e",
      error_link_timeout: "kekeyh",
      error_nooperation: "zatxb8",
      error_notime: "y9zdy3",
      error_offer_sdp_type: "1nkoqh",
      error_peer_connection_create_fail: "dxxl29",
      fball_downloadactivity_click: "7r8tss",
      fball_downloadactivity_impression: "5jkeoy",
      fball_impression: "r0seor",
      fb_share: "caxi2u",
      first_purchase_gift: "igtk0i",
      friend_accept: "1fg8pm",
      friend_invite: "vbjo45",
      gamecenter_login: "l1xtmb",
      gameforbidden_download_click: "zeyw4h",
      gameforbidden_impression: "68g52l",
      gameforbidden_quit_click: "5c0pgv",
      gold: "sumuzw",
      invite_friend_match: "2n30oh",
      level: "eeyw17",
      loading_completed: "fttnn9",
      login_completed: "dqk6to",
      login_failed_facebook: "78glco",
      login_failed_google: "62w3x9",
      login_failed_twitter: "z6dqd1",
      login_start: "slwb25",
      menu_downloadactivity_click: "ea3qih",
      menu_impression: "6vl2ze",
      midas_pay_start: "f01bpx",
      one_man_squad: "kqfj89",
      patch_check: "jr4qc0",
      patch_completed: "br7n53",
      patch_start: "u076r7",
      platinum: "8861yo",
      play_loading_impression: "ca1jzx",
      privatepolicy_accept: "gtc510",
      privatepolicy_acceptall: "u86jg1",
      privatepolicy_persuade_accept: "guxgpz",
      privatepolicy_persuade_refuse: "4ylflm",
      privatepolicy_refuse: "3vyymd",
      privatepolicy_start: "43gt5w",
      purchase: "gwbxfa",
      purchase_consider: "6bw73p",
      pwa_popup_cancel_click: "7gc20k",
      pwa_popup_impression_and: "i7km9w",
      pwa_popup_impression_ios: "u0vms7",
      pwa_popup_install_click: "eo2j8x",
      queue_custompopup_download_click: "vq2weg",
      queue_custompopup_impression: "5e8itf",
      queue_popup_download_click: "io4s32",
      queue_popup_impression: "5d3fa1",
      reach_level_10: "shgizn",
      reach_level_15: "7lu2dp",
      reach_level_20: "boxlu4",
      reach_level_25: "pcnotq",
      reach_level_30: "w13arh",
      reach_level_35: "vu0atq",
      reach_level_40: "eb31gg",
      reach_level_5: "dwrpg9",
      register_completed: "rxsx5q",
      register_old_completed: "iaclyr",
      sdk_init: "6573hu",
      silver: "swqra0",
      solo: "1n9q93",
      squad: "syajcv",
      tutorial_completed: "8f78wr",
      tutorial_start: "dkai9w",
      video_audio_ready: "p2h7hn",
      web_launch: "s7zrnu",
      week_sign_in: "zf7bhm",
      verify_impression: "l9ajrl",
      verify_success: "lwtopk",
      rotate_1: "j1jgqn",
      rotate_3: "amdfz7",
      google_remind_popup_impression: "xp8g4n",
      guest_remind_popup_impression: "5hhcjp",
      pc_popup_impression: "j2z6rr",
      ovm_popup_impression: "svdot5",
      loading_index: "ve6hg2"
    }
  }
};